import { ReactNode } from 'react';

type EntityConfig = {
  pattern: RegExp;
  url: string;
  icon: ReactNode;
};

const ICON_STYLE = { verticalAlign: '-2px', marginRight: 3 };

const ENTITIES: EntityConfig[] = [
  {
    pattern: /\bDatabricks\b/g,
    url: 'https://www.databricks.com',
    icon: (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={ICON_STYLE}>
        <path d="M.95 14.184L12 20.403l9.919-5.55v2.21L12 22.662l-10.484-5.96-.565.308v.77L12 24l11.05-6.218v-4.317l-.515-.309L12 19.118l-9.867-5.653v-2.21L12 16.805l11.05-6.218V6.32l-.515-.308L12 11.974 2.647 6.681 12 1.388l7.76 4.368.668-.411v-.566L12 0 .95 6.27v.72L12 13.207l9.919-5.55v2.26L12 15.52 1.516 9.56l-.565.308Z" />
      </svg>
    ),
  },
  {
    pattern: /\bCardClues\b/g,
    url: 'https://cardclues.com',
    icon: (
      <svg width="12" height="12" viewBox="0 0 736 681" fill="none" style={ICON_STYLE}>
        <path d="M362.288 23.0045C370.277 8.79431 385.307 0 401.604 0H505.343C522.592 0 533.456 18.5812 525.001 33.6208L435.707 192.458C427.719 206.668 412.689 215.463 396.392 215.463H292.652C275.404 215.463 264.54 196.881 272.995 181.842L362.288 23.0045Z" fill="currentColor"/>
        <path d="M234.532 255.773C242.547 241.563 257.627 232.769 273.979 232.769H378.066C395.373 232.769 406.273 251.35 397.79 266.389L308.197 425.227C300.181 439.437 285.101 448.231 268.749 448.231H164.662C147.356 448.231 136.455 429.65 144.938 414.61L234.532 255.773Z" fill="currentColor"/>
        <path d="M428.917 255.773C436.906 241.563 451.936 232.769 468.233 232.769H571.972C589.22 232.769 600.085 251.35 591.63 266.389L502.336 425.227C494.347 439.437 479.318 448.231 463.02 448.231H359.281C342.033 448.231 331.169 429.65 339.624 414.61L428.917 255.773Z" fill="currentColor"/>
        <path d="M296.525 488.542C304.513 474.331 319.543 465.537 335.84 465.537H439.58C456.828 465.537 467.692 484.118 459.237 499.158L369.943 657.995C361.955 672.205 346.925 681 330.628 681H226.889C209.64 681 198.776 662.418 207.231 647.379L296.525 488.542Z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    pattern: /\bLinkedIn\b/g,
    url: 'https://www.linkedin.com/in/vincentliaw',
    icon: (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={ICON_STYLE}>
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    pattern: /\bGitHub\b/g,
    url: 'https://github.com/liawesomesaucer',
    icon: (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={ICON_STYLE}>
        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
      </svg>
    ),
  },
  {
    pattern: /\bvincentcliaw\.com\b/g,
    url: 'https://vincentcliaw.com',
    icon: (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={ICON_STYLE}>
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
  },
  {
    pattern: /\bvincentcliaw@gmail\.com\b/g,
    url: 'mailto:vincentcliaw@gmail.com',
    icon: (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={ICON_STYLE}>
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
  },
  {
    pattern: /\bresume\b/gi,
    url: '/Vincent-Liaw-Resume-2026.pdf',
    icon: (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={ICON_STYLE}>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    pattern: /\buntethered\.one\b/g,
    url: 'https://untethered.one',
    icon: (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={ICON_STYLE}>
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
  },
  {
    pattern: /(?<![.\w])TSM(?![.\w])/gi,
    url: 'https://tsm.gg',
    icon: <img src="/tsm-logo.svg" alt="TSM" width="12" height="12" style={ICON_STYLE} />,
  },
  {
    pattern: /\bTeam SoloMid\b/gi,
    url: 'https://tsm.gg',
    icon: <img src="/tsm-logo.svg" alt="TSM" width="12" height="12" style={ICON_STYLE} />,
  },
  {
    pattern: /\bLakeflow Connect\b/g,
    url: 'https://www.databricks.com/product/data-ingestion',
    icon: (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={ICON_STYLE}>
        <path d="M.95 14.184L12 20.403l9.919-5.55v2.21L12 22.662l-10.484-5.96-.565.308v.77L12 24l11.05-6.218v-4.317l-.515-.309L12 19.118l-9.867-5.653v-2.21L12 16.805l11.05-6.218V6.32l-.515-.308L12 11.974 2.647 6.681 12 1.388l7.76 4.368.668-.411v-.566L12 0 .95 6.27v.72L12 13.207l9.919-5.55v2.26L12 15.52 1.516 9.56l-.565.308Z" />
      </svg>
    ),
  },
];

/**
 * Preprocesses markdown text to auto-link known entities.
 * Skips entities already inside markdown links.
 */
export function enrichMarkdown(text: string): string {
  let result = text;
  for (const entity of ENTITIES) {
    // Reset lastIndex for global regexes
    entity.pattern.lastIndex = 0;
    result = result.replace(entity.pattern, (match, offset) => {
      // Skip if already inside a markdown link: [text](url)
      const before = result.slice(Math.max(0, offset - 200), offset);
      const after = result.slice(offset + match.length, offset + match.length + 200);
      // Inside link text [...]
      if (/\[[^\]]*$/.test(before) && /^[^\[]*\]\(/.test(after)) return match;
      // Inside link URL ](...)
      if (/\]\([^)]*$/.test(before)) return match;
      // Part of a URL (preceded or followed by . / : without space)
      if (/[.:\/]$/.test(before.trim()) || /^[.:\/]/.test(after)) return match;
      return `[${match}](${entity.url})`;
    });
  }
  return result;
}

/**
 * Custom link renderer for react-markdown that adds icons.
 */
export function SmartLink({ href, children }: { href?: string; children?: ReactNode }) {
  const entity = ENTITIES.find((e) => {
    if (!href) return false;
    if (e.url === href) return true;
    try {
      const entityHost = new URL(e.url, window.location.origin).hostname;
      const linkHost = new URL(href, window.location.origin).hostname;
      return entityHost === linkHost;
    } catch {
      return false;
    }
  });

  const target = href?.startsWith('/') || href?.startsWith('mailto:') ? undefined : '_blank';
  const rel = target === '_blank' ? 'noopener noreferrer' : undefined;

  return (
    <>
      {entity?.icon}
      <a href={href} target={target} rel={rel}>
        {children}
      </a>
    </>
  );
}
